module.exports = {
    "my.topic": "My Topic",
    "reply.topic": "Replied Topic",
    "his.topic": "Their replied topics",
    "pub.topic": "My replied topics"
}


// WEBPACK FOOTER //
// ./src/pages/myReply/i18n/locale.en.js